export enum SearchStatus {
    Error = 1,
    Loading = 2,
    Success = 3
}
